import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { XMarkIcon } from "@heroicons/react/20/solid";
import React, { useEffect } from "react";
import { NotificationProps } from "../../models/interfaces/notification.interface";

const ErrorNotification: React.FC<NotificationProps> = (props: NotificationProps) => {
    const {
        notification,
        onClose,
    } = props;

    useEffect(() => {
        const duration = notification.duration || 3000;

        const timer = setTimeout(() => {
            onClose();
        }, duration);

        return () => {
            clearTimeout(timer);
        };
    }, [notification.duration, onClose]);

    return (
        <div
            className="pointer-events-auto w-full overflow-hidden bg-error text-[#F0FEF6] rounded-2xl shadow-notification flex items-start p-3 pb-1 pl-4 gap-2 min-h-[48px]">
            <div className="flex-shrink-0">
                <ExclamationCircleIcon aria-hidden="true" className="h-7 w-7"/>
            </div>
            <div className="flex-1">
                <p className="text-base font-normal mt-[2px]">{notification.message}</p>
            </div>
            <div className="ml-auto flex-shrink-0">
                <button
                    type="button"
                    onClick={onClose}
                    className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-gray-light text-gray hover:text-primary focus:outline-none"
                >
                    <XMarkIcon aria-hidden="true" className="h-7 w-7"/>
                </button>
            </div>
        </div>
    );
}

export default ErrorNotification;
